<template>

  <div>
    <h5>Información de los estados de las solicitudes de afiliación</h5>
    <div class="row mt-2 mb-3">

      <div class="col-md-8">
        <el-descriptions :column="2" border>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              Solicitudes de afiliaciones
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="100"
                  :legend="false"
                  color="#0077c2"
                  emptyColorFill="#80d6ff"
                  emptyColor="#42a5f5"
                  :size="size"
                  thickness="5"
                  emptyThickness="3"
                  lineMode="out 5"
                  animation="rs 700 1000"
                  fontSize="1.5rem"
                  fontColor="#000">
              <span slot="legend-caption">
                {{ this.affiliation.affiliation }}
              </span>
                </vue-ellipse-progress>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              Afiliación incorporada
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="ratingProgressIncorporate"
                  :legend="false"
                  color="#7da453"
                  emptyColorFill="#e1ffb1"
                  emptyColor="#aed581"
                  :size="size"
                  thickness="7"
                  emptyThickness="3"
                  lineMode="out 4"
                  animation="rs 600 900"
                  fontSize="1.5rem"
                  fontColor="#000">
                  <span slot="legend-caption">
                    {{ this.affiliation.incorporate }}
                  </span>
                </vue-ellipse-progress>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              Rechazada por Servel
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="ratingProgressRefuseServel"
                  :legend="false"
                  color="#9b0000"
                  emptyColorFill="#ff5131"
                  emptyColor="#9b0000"
                  :size="size"
                  thickness="5"
                  emptyThickness="3"
                  lineMode="out 5"
                  animation="rs 700 1000"
                  fontSize="1.5rem"
                  fontColor="#000">
                  <span slot="legend-caption">
                    {{ this.affiliation.refuseServel }}
                  </span>
                </vue-ellipse-progress>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              Cancelada solicitud de afiliación
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="ratingProgressCancel"
                  :legend="false"
                  color="#bc5100"
                  emptyColorFill="#ffb04c"
                  emptyColor="#f57f17"
                  :size="size"
                  thickness="5"
                  emptyThickness="3"
                  lineMode="out 5"
                  animation="rs 700 1000"
                  fontSize="1.5rem"
                  fontColor="#000">
                  <span slot="legend-caption">
                    {{ this.affiliation.cancel }}
                  </span>
                </vue-ellipse-progress>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              Aprobadas por partido político
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="ratingProgressAproved"
                  :legend="false"
                  color="#4fc3f7"
                  emptyColorFill="#8bf6ff"
                  emptyColor="#0093c4"
                  :size="size"
                  thickness="5"
                  emptyThickness="3"
                  lineMode="out 5"
                  animation="rs 700 1000"
                  fontSize="1.5rem"
                  fontColor="#000">
                  <span slot="legend-caption">
                    {{ this.affiliation.aproved }}
                  </span>
                </vue-ellipse-progress>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              Pendiente reclamación por solicitante
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="ratingProgressPendingReclaim"
                  :legend="false"
                  color="#ffb74d"
                  emptyColorFill="#ffe97d"
                  emptyColor="#c88719"
                  :size="size"
                  thickness="5"
                  emptyThickness="3"
                  lineMode="out 4"
                  animation="rs 700 1000"
                  fontSize="1.5rem"
                  fontColor="#000">
                  <span slot="legend-caption">
                    {{ this.affiliation.pendingReclaim }}
                  </span>
                </vue-ellipse-progress>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              Rechazada por partido político
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="ratingProgressRefuse"
                  :legend="false"
                  color="#e64a19"
                  emptyColorFill="#ff7d47"
                  emptyColor="#ac0800"
                  :size="size"
                  thickness="4"
                  emptyThickness="3"
                  lineMode="out 1"
                  animation="rs 700 1000"
                  fontSize="1.5rem"
                  fontColor="#000">
                  <span slot="legend-caption">
                    {{ this.affiliation.refuse }}
                  </span>
                </vue-ellipse-progress>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              En Revisión Servel
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="ratingProgressReviewServel"
                  :legend="false"
                  color="#b0bec5"
                  emptyColorFill="#e2f1f8"
                  emptyColor="#808e95"
                  :size="size"
                  thickness="5"
                  emptyThickness="3"
                  lineMode="out 5"
                  animation="rs 700 1000"
                  fontSize="1.5rem"
                  fontColor="#000">
                  <span slot="legend-caption">
                    {{ this.affiliation.reviewServel }}
                  </span>
                </vue-ellipse-progress>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              Rechazada por Plazo Máximo
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="ratingProgressRefuseDeadline"
                  :legend="false"
                  color="#ff3d00"
                  emptyColorFill="#ff7539"
                  emptyColor="#c30000"
                  :size="size"
                  thickness="5"
                  emptyThickness="3"
                  lineMode="out 1"
                  animation="rs 700 1000"
                  fontSize="1.5rem"
                  fontColor="#000">
                  <span slot="legend-caption">
                    {{ this.affiliation.refuseDeadline }}
                  </span>
                </vue-ellipse-progress>
              </div>
            </div>
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              Rechazada por Plazo Máximo de reclamación
            </template>
            <div class="row text-center">
              <div class="col-12">
                <vue-ellipse-progress
                  :progress="ratingProgressRefuseDeadlineReclaim"
                  :legend="false"
                  color="#bf360c"
                  emptyColorFill="#f9683a"
                  emptyColor="#870000"
                  :size="size"
                  thickness="4"
                  emptyThickness="3"
                  lineMode="out 2"
                  animation="rs 700 1000"
                  fontSize="1.5rem"
                  fontColor="#000">
                  <span slot="legend-caption">
                    {{ this.affiliation.refuseDeadlineReclaim }}
                  </span>
                </vue-ellipse-progress>
              </div>
            </div>

          </el-descriptions-item>

        </el-descriptions>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12">
        <v-chart
          class="chart"
          :option="option"
          autoresize/>
      </div>
    </div>

  </div>


</template>

<script>
import {Descriptions, DescriptionsItem, Progress, Tag} from "element-ui";
import VChart from 'vue-echarts'

export default {
  name: "ChartAffiliation",
  components: {
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Tag.name]: Tag,
    [Progress.name]: Progress,
    VChart,
  },
  props: {
    affiliation: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      size: 68,
      option: {
        title: {
          text: "Solicitud de Afiliaciones",
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.affiliation.listActivities.map(i => i.time)
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'Afiliación',
            type: 'line',
            stack: 'Total',
            data: this.affiliation.listActivities.map(i => i.count)
          }
        ]
      },
    };
  },
  computed: {
    ratingProgressIncorporate() {
      return (this.affiliation.incorporate * 100) / this.affiliation.affiliation
    },
    ratingProgressRefuseServel() {
      return (this.affiliation.refuseServel * 100) / this.affiliation.affiliation
    },
    ratingProgressCancel() {
      return (this.affiliation.cancel * 100) / this.affiliation.affiliation
    },
    ratingProgressAproved() {
      return (this.affiliation.aproved * 100) / this.affiliation.affiliation
    },
    ratingProgressRefuse() {
      return (this.affiliation.refuse * 100) / this.affiliation.affiliation
    },
    ratingProgressPendingReclaim() {
      return (this.affiliation.pendingReclaim * 100) / this.affiliation.affiliation
    },
    ratingProgressReviewServel() {
      return (this.affiliation.reviewServel * 100) / this.affiliation.affiliation
    },
    ratingProgressRefuseDeadline() {
      return (this.affiliation.refuseDeadline * 100) / this.affiliation.affiliation
    },
    ratingProgressRefuseDeadlineReclaim() {
      return (this.affiliation.refuseDeadlineReclaim * 100) / this.affiliation.affiliation
    }
  },
}
</script>

<style scoped>
.chart {
  height: 550px;
}
</style>
